/* ── Design tokens ─────────────────────────────────────── */
:root {
  /* Palette */
  --canvas:       #F6F3EE;
  --surface:      #EFE9DF;
  --surface-2:    #E7DFD2;
  --amber:        #D97E24;
  --amber-strong: #9A520D;
  --amber-dim:    rgba(217, 126, 36, 0.14);
  --amber-border: rgba(217, 126, 36, 0.40);
  --steel:        #3E7A94;
  --steel-dim:    rgba(62, 122, 148, 0.13);
  --text:         #262119;
  --soft:         #5C5346;
  --muted:        #8A7F70;
  --border:       rgba(38, 33, 25, 0.10);
  --border-md:    rgba(38, 33, 25, 0.17);
  --tint:         rgba(38, 33, 25, 0.045);
  --tint-md:      rgba(38, 33, 25, 0.08);
  --up:           #3E7D3D;
  --up-dim:       rgba(62, 125, 61, 0.14);
  --down:         #B84A3C;
  --down-dim:     rgba(184, 74, 60, 0.12);
  --flat:         #8A7F70;

  /* Typography */
  --font-display: "Bricolage Grotesque", system-ui, sans-serif;
  --font-sans:   "DM Sans", system-ui, sans-serif;
  --font-mono:   ui-monospace, SFMono-Regular, Menlo, monospace;

  /* Layout */
  --header-h:   56px;
  --max-w:      1440px;
  --radius:     16px;
  --radius-sm:  10px;
}

/* ── Reset ──────────────────────────────────────────────── */
*, *::before, *::after { box-sizing: border-box; }

html {
  min-height: 100%;
  background: var(--canvas);
  color-scheme: light;
}

body {
  margin: 0;
  min-height: 100dvh;
  background: var(--canvas);
  color: var(--text);
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.55;
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
}

h1, h2, h3, h4, p, dl, dd { margin: 0; }

svg { display: block; fill: currentColor; }

button {
  border: 0;
  cursor: pointer;
  font: inherit;
  background: transparent;
}

button:disabled { cursor: not-allowed; opacity: 0.45; }

input {
  font: inherit;
  background: transparent;
  border: 0;
  outline: 0;
  color: inherit;
}

[hidden] { display: none !important; }

@media (prefers-reduced-motion: no-preference) {
  html { scroll-behavior: smooth; }
}

/* ── Focus ring ─────────────────────────────────────────── */
:focus-visible {
  outline: 2px solid var(--amber-strong);
  outline-offset: 2px;
  border-radius: 3px;
}
